import React from 'react';

import type { SmartContractVerificationConfig } from 'types/client/contract';

import { useI18n } from 'lib/i18n/context';

import ContractVerificationMethod from '../ContractVerificationMethod';
import ContractVerificationFieldCode from '../fields/ContractVerificationFieldCode';
import ContractVerificationFieldCompiler from '../fields/ContractVerificationFieldCompiler';
import ContractVerificationFieldConstructorArgs from '../fields/ContractVerificationFieldConstructorArgs';
import ContractVerificationFieldEvmVersion from '../fields/ContractVerificationFieldEvmVersion';
import ContractVerificationFieldName from '../fields/ContractVerificationFieldName';
import { CONTRACT_VERIFICATION_FIELD_KEYS, CONTRACT_VERIFICATION_METHOD_TITLE_KEYS } from '../i18n';

const ContractVerificationVyperContract = ({ config }: { config: SmartContractVerificationConfig }) => {
  const { t } = useI18n();
  return (
    <ContractVerificationMethod title={ t(CONTRACT_VERIFICATION_METHOD_TITLE_KEYS['vyper-code']) }>
      <ContractVerificationFieldName hint={ t(CONTRACT_VERIFICATION_FIELD_KEYS.name.hintPart2) }/>
      <ContractVerificationFieldCompiler isVyper/>
      { config?.is_rust_verifier_microservice_enabled && <ContractVerificationFieldEvmVersion isVyper/> }
      <ContractVerificationFieldCode isVyper/>
      { !config?.is_rust_verifier_microservice_enabled && <ContractVerificationFieldConstructorArgs/> }
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationVyperContract);
